import React, { useState } from 'react';
import arrowUpIcon from '../../../../../../assets/image/arrow_up.svg';
import arrowDownIcon from '../../../../../../assets/image/arrowD.svg';

export default function ProfitByProductTableBodyComponent({
	data,
	params,
	periods,
	selectedColumnsList,
}) {
	const [isSelectedRows, setIsSelectedRows] = useState([]);
	const handleArrowIcon = (id) => {
		setIsSelectedRows((prev) =>
			prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
		);
	};
	return data.flatMap((item, profitIndex) => {
		const isOpen = isSelectedRows.includes(item.product_id);
		const ItemRow = (
			<tr key={`product-${profitIndex}`}>
				<td className="name-col">
					<div className="d-flex gap-5 align-items-center">
						<img
							src={isOpen ? arrowUpIcon : arrowDownIcon}
							alt="arrow-icon"
							className="cursor-pointer"
							onClick={() => handleArrowIcon(item.product_id)}
						/>
						<div className="tex-black fw-light">
							{item.product_name} ({item.product_code})
						</div>
					</div>
				</td>
				{periods.map((p, i) => {
					const key = p.label;
					const metrics = item.metrics[key] || {};

					return selectedColumnsList.map((m, idx) => (
						<td key={`item-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
					));
				})}
			</tr>
		);

		const batchRows =
			item.batches && item.batches.length > 0 && isOpen
				? item.batches.map((batch, batchIndex) => (
						<tr key={`product-${profitIndex}-${batchIndex}`}>
							<td
								className="name-col"
								style={{ paddingLeft: '30px' }}
							>
								{batch.batch_no}
							</td>

							{periods.map((p, i) => {
								const key = p.label;
								const metrics = batch.metrics[key] || {};

								return selectedColumnsList.map((m, idx) => (
									<td key={`product-${i}-${idx}`}>{metrics[m.key] ?? 0}</td>
								));
							})}
						</tr>
					))
				: [];

		return [ItemRow, ...batchRows];
	});
}
